export default {
  /* Authentication apis */
  adminLogin: "/app/rest/v2/oauth/token",

  /* entity apis */
  videoEntity: "/app/rest/v2/entities/edfor$VideoUpload",
  courseEntity: "/app/rest/v2/entities/edfor$Course",
  addLiveCourse: "/app/rest/v2/entities/edfor$LiveCourses",
  /* Services*/
  videoUpload: "/app/rest/myapi/videoUpload",
  imageUpload: "/app/rest/myapi/imageUpload",
  addCourse: "/app/rest/myapi/addCourse",
  addVideo: "/app/rest/myapi/addVideos",
  courseById: "/app/rest/myapi/course?courseId=",
  videoByCourseId: "/app/rest/myapi/videos?courseId=",
  courseEdit: "/app/rest/myapi/courseEdit",
  removeVideo: "/app/rest/myapi/removeVideo?videoId=",
  editVideo: "/app/rest/myapi/editVideos",
  liveCourseByCourseId: "/app/rest/myapi/lives?courseId=",
  editLiveCourse: "/app/rest/myapi/liveCourseEdit",
  removeLiveCourse: "/app/rest/myapi/removeLive?courseId=",
  deleteCourse: "/app/rest/myapi/removeCourse?courseId="
};
